<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Solicitar Treinamento</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestTraining">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column is-one-third">
            <b-field label="Tipo do Treinamento *">
              <b-field style="padding-top: 8px">
                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="true"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Online</span>
                </b-radio>

                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="false"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Presencial</span>
                </b-radio>
                <span @click="formatAlert" v-if="hasFormat">
                  <b-icon
                    type="is-info"
                    icon="info-circle"
                    class="format-icon"
                  ></b-icon>
                </span>
              </b-field>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="request.eventInfo.attendeeQty ? 'Público estimado *' : ''"
              label-position="on-border"
            >
              <b-input
                type="number"
                placeholder="Público estimado *"
                v-model="request.eventInfo.attendeeQty"
              ></b-input>
            </b-field>
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.studentsCourses.length
              ? 'Cursos dos estudantes *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.studentsCourses"
            :data="coursesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Cursos dos estudantes *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <date-time-options />

        <b-field
          :label="
            request.eventInfo.suggestedThemes.length
              ? 'Temas para o treinamento *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.suggestedThemes"
            :data="themesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Sugestões de Temas"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          :label="
            request.eventInfo.themesDescription ? 'Descrição dos temas *' : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Por favor, descreva brevemente cada tema sugerido. Texto de no mínimo 140 caracteres"
            v-model="request.eventInfo.themesDescription"
          />
        </b-field>
        <span
          :style="descriptionLength >= 140 ? 'color: green' : 'color: red'"
          style="display: table; margin-left: auto"
        >
          {{ descriptionLength }} > 140
        </span>

        <b-field label="Se desejar, anexe um material de suporte em PDF">
          <b-field>
            <div class="columns">
              <div class="column is-narrow">
                <button
                  type="button"
                  class="button is-empower-gray"
                  @click="$refs.pdf_training.click()"
                >
                  Anexar PDF (max. 5mb)
                </button>
                <input
                  id="pdf_training"
                  type="file"
                  ref="pdf_training"
                  style="display: none"
                  @change="handleFileUpload()"
                />
              </div>

              <div class="column">
                <p
                  v-if="filename"
                  :style="[!isMobile ? { 'margin-top': '0.4rem' } : null]"
                >
                  ✅ {{ filename }}&nbsp;
                  <a class="delete is-medium" @click="excludeFile"></a>
                </p>
              </div>
            </div>
          </b-field>
        </b-field>

        <b-field
          :label="request.organizationComments ? 'Algum comentário?' : ''"
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Algum comentário?"
            v-model="request.organizationComments"
          />
        </b-field>

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey"
        >
          <div class="field">
            <b-checkbox v-model="terms.form">
              Aceito enviar o formulário disponibilizado pela Empower a todos os
              participantes da ação.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos do treinamento e coletar as devidas
              autorizações para uso de imagem dos participantes que aparecerem
              nos prints/fotos enviados.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin da OE.
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            :disabled="pendencies.length || isLoading"
            class="button is-primary"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Treinamento
          </button>
        </div>

        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { request } from "../../../mixins/request";
import { cursos } from "../../../assets/js/cursos";
import dateTimeOptions from "./date-time-options/DateTimeOptions";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive, request],

  components: {
    dateTimeOptions,
    Pendencies,
  },

  props: ["minPublic", "advance"],

  data() {
    const today = new Date();
    return {
      isLoading: false,
      minDate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + this.advance * 7
      ),
      hasFormat: false,

      request: {
        opportunity: null,
        requestType: "training",
        eventInfo: {
          suggestedThemes: [],
          themesDescription: "",
          isOnline: "",
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null,
            },
            second: {
              date: null,
              start: null,
              end: null,
            },
            third: {
              date: null,
              start: null,
              end: null,
            },
          },
          attendeeQty: null,
          studentsCourses: []
        },
        organizationComments: "",
      },

      pdf_training: "",
      filename: "",
      terms: {
        form: false,
        photos: false,
        post: false,
      },

      themesArray: [],
      coursesArray: []
    };
  },

  methods: {
    handleFileUpload() {
      this.filename = this.$refs.pdf_training.files[0].name;
      this.pdf_training = this.$refs.pdf_training.files[0];
    },

    excludeFile() {
      this.filename = "";
      this.pdf_lecture = "";
    },

    requestTraining() {
      if (this.pdf_training.size > 5000000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE" });
        return;
      }

      this.request.eventInfo.dateOptions.first.start =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.first.date,
          this.request.eventInfo.dateOptions.first.start
        );
      this.request.eventInfo.dateOptions.first.end =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.first.date,
          this.request.eventInfo.dateOptions.first.end
        );
      this.request.eventInfo.dateOptions.second.start =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.second.date,
          this.request.eventInfo.dateOptions.second.start
        );
      this.request.eventInfo.dateOptions.second.end =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.second.date,
          this.request.eventInfo.dateOptions.second.end
        );
      this.request.eventInfo.dateOptions.third.start =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.third.date,
          this.request.eventInfo.dateOptions.third.start
        );
      this.request.eventInfo.dateOptions.third.end =
        this.adjustRequestDateAndTime(
          this.request.eventInfo.dateOptions.third.date,
          this.request.eventInfo.dateOptions.third.end
        );

      let formData = new FormData();
      formData.append("pdf_training", this.pdf_training);
      formData.append("request", JSON.stringify(this.request));

      this.isLoading = true;
      this.$store
        .dispatch("makeRequest", {
          to: "training",
          data: formData,
        })
        .then((res) => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação de Treinamento Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close(),
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    formatAlert() {
      this.$buefy.dialog.alert(
        "Esta empresa realiza treinamentos apenas neste formato."
      );
    },
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"]),

    pendencies() {
      const pendencies = [];

      if (!this.terms.form || !this.terms.photos || !this.terms.post) {
        pendencies.push("Aceitar os termos de contrapartidas");
      }

      if (this.request.eventInfo.isOnline === "") {
        pendencies.push("Tipo de treinamento");
      }

      if (this.request.eventInfo.studentsCourses.length < 1) {
        pendencies.push("Informe os cursos dos estudantes");
      }

      if (this.request.eventInfo.attendeeQty < this.minPublic) {
        pendencies.push("O público estimado é menor que o público mínimo");
      }

      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Primeira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.first.start) {
        pendencies.push("Horário de início da primeira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.first.end) {
        pendencies.push("Horário final da primeira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.second.date) {
        pendencies.push("Segunda opção de data");
      }

      if (!this.request.eventInfo.dateOptions.second.start) {
        pendencies.push("Horário de início da segunda opção de data");
      }

      if (!this.request.eventInfo.dateOptions.second.end) {
        pendencies.push("Horário final da segunda opção de data");
      }

      if (!this.request.eventInfo.dateOptions.third.date) {
        pendencies.push("Terceira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.third.start) {
        pendencies.push("Horário de início da terceira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.third.end) {
        pendencies.push("Horário final da terceira opção de data");
      }

      if (this.request.eventInfo.suggestedThemes.length == 0) {
        pendencies.push("Temas para o treinamento");
      }

      if (!this.request.eventInfo.themesDescription) {
        pendencies.push("Descrição de cada tema");
      } else if (this.request.eventInfo.themesDescription.length < 140) {
        pendencies.push("A descrição precisa ter no mínimo 140 caracteres");
      }

      return pendencies;
    },

    descriptionLength() {
      return this.request.eventInfo.themesDescription.length;
    },
  },

  mounted() {
    this.coursesArray = cursos;
    
    this.request.opportunity = this.opportunityBeingVisited._id;

    this.request.eventInfo.attendeeQty = this.minPublic;

    let themes = this.opportunityBeingVisited.training.themes;
    let specificThemes = this.opportunityBeingVisited.training.specificThemes;

    let index = themes.findIndex((t) => {
      return t === "Outros Temas de Interesse da OE";
    });
    if (index !== -1) themes.splice(index, 1);

    index = specificThemes.findIndex((t) => {
      return t === "Outros Temas de Interesse da OE";
    });
    if (index !== -1) specificThemes.splice(index, 1);

    this.themesArray = themes.concat(specificThemes);
    this.themesArray.push("Outros Temas de Interesse da OE");

    if (this.opportunityBeingVisited.training.format) {
      if (this.opportunityBeingVisited.training.format == "online") {
        this.request.eventInfo.isOnline = true;
        this.hasFormat = true;
      } else if (this.opportunityBeingVisited.training.format == "faceToFace") {
        this.request.eventInfo.isOnline = false;
        this.hasFormat = true;
      }
    }
  },
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}

.format-icon {
  cursor: pointer;
}
</style>
